import AXIOS from '@/axios-instance';

export default {

  saveDocument(formData, uuid, elementId) {
    return AXIOS.post( '/bpmn/'+uuid+"/element/"+elementId+"/document",
    formData,
    {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    });
  },
  downloadDocument(uuid, elementId, documentId) {
    return AXIOS.get("/bpmn/"+uuid+"/element/"+elementId+"/document/"+documentId, {
        responseType: 'blob',
    });
  },
  getDocumentList(uuid, elementId) {
    return AXIOS.get("/bpmn/"+uuid+"/element/"+elementId+"/document");
  },
  removeDocument(uuid, elementId, documentId) {
    return AXIOS.delete("/bpmn/"+uuid+"/element/"+elementId+"/document/"+documentId);
  }
}